import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.str)?_c('span',[_c('span',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.str.slice(0, _vm.head)))]),_vm._v(_vm._s(_vm.str.slice(_vm.head, _vm.head + _vm.tail))),_c(VIcon,[_vm._v("mdi-dots-horizontal")]),_vm._v(_vm._s(_vm.str.slice(_vm.str.length - _vm.tail))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }